<template>
  <div class="home">
    <Bloco2Cover />
    <Bloco3Prevencao />
    <Bloco4Boletins />
    <Bloco5Noticias />
    <Bloco5Videos />
    <Bloco6NotasOrientativas />
    <Bloco7Sintomas />
    <Bloco8Transparencia />
    <Bloco9Agradecimento />
    <bloco10-coe />
    <Bloco99Footer />
    <!--<img alt="Vue logo" src="../assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/>-->

  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

import Bloco2Cover from "../components/homeBlocos/Bloco2Cover";
import Bloco3Prevencao from "../components/homeBlocos/Bloco3Prevencao";
import Bloco4Boletins from "../components/homeBlocos/Bloco4Boletins";
import Bloco5Noticias from "../components/homeBlocos/Bloco5Noticias";
import Bloco5Videos from "../components/homeBlocos/Bloco5Videos";
import Bloco6NotasOrientativas from "../components/homeBlocos/Bloco6NotasOrientativas";
import Bloco7Sintomas from "../components/homeBlocos/Bloco7Sintomas";
import Bloco8Transparencia from "../components/homeBlocos/Bloco8Transparencia";
import Bloco9Agradecimento from "../components/homeBlocos/Bloco9Agradecimento";
import Bloco99Footer from "../components/homeBlocos/Bloco99Footer";
import Bloco10Coe from "../components/homeBlocos/Bloco10Coe";

export default {
  name: 'Home',
  components: {
    Bloco10Coe,
    Bloco99Footer,
    Bloco9Agradecimento,
    Bloco8Transparencia,
    Bloco7Sintomas,
    Bloco6NotasOrientativas,
    Bloco5Noticias,
    Bloco5Videos,
    Bloco4Boletins,
    Bloco3Prevencao,
    Bloco2Cover,
    // HelloWorld
  },
}
</script>
